<!-- Login del portal de clientes. Rediseño portado del login de newcube (clases lg2-*), con el rojo
     de marca de esta app (#ac2023) como color de acento. Marca a la IZQUIERDA (logo de la empresa,
     que llega por URL en base64Logo) y formulario a la DERECHA. En mobile la marca pasa a ser un
     encabezado compacto y el formulario sube encima como una hoja. Movimiento solo decorativo y
     lento, apagado con prefers-reduced-motion. -->
<div class="lg2-page">

  <!-- ── Panel de marca (izquierda; en mobile = encabezado) ── -->
  <aside class="lg2-brand" aria-roledescription="carousel" aria-label="What the customer portal does"
    (mouseenter)="pauseSlides(true)" (mouseleave)="pauseSlides(false)">
    <!-- capas de profundidad: grilla sutil + orbes de luz que se desplazan lento -->
    <div class="lg2-brand-grid" aria-hidden="true"></div>
    <div class="lg2-orb lg2-orb--a" aria-hidden="true"></div>
    <div class="lg2-orb lg2-orb--b" aria-hidden="true"></div>
    <div class="lg2-orb lg2-orb--c" aria-hidden="true"></div>

    <!-- Marca: igual que newcube (cubo + wordmark blanco, sin tarjeta). Si la URL trae el logo propio
         de la empresa (white-label), se muestra ese sobre una pastilla blanca, porque puede venir de
         cualquier color y no siempre se lee sobre el degradado. -->
    <div class="lg2-mark">
      <ng-container *ngIf="!hasCompanyLogo">
        <img src="assets/icon.png" alt="" class="lg2-mark-cube">
        <span class="lg2-mark-word">CUBE</span>
      </ng-container>
      <span class="lg2-mark-logo" *ngIf="hasCompanyLogo"><img [src]="base64Logo" alt="Company logo"></span>
      <span class="lg2-mark-tag">{{ 'ModuleLogin.labelBrandTag' | translate }}</span>
    </div>
    <!-- solo mobile: frase corta bajo la marca (el slider se oculta en pantallas chicas) -->
    <p class="lg2-mobile-tag">{{ 'ModuleLogin.labelBrandMobile' | translate }}</p>

    <!-- ── Slider: una ilustracion (HTML/CSS) por vista REAL del portal (menu: Dashboard, Service Work
         Order, Service Sites / Assets Management). Los textos de las ilustraciones son los mismos
         labels que muestran esas pantallas. Las animaciones internas solo corren en .is-active. ── -->
    <div class="lg2-slides">

      <!-- 1 · Dashboard (cs-portal): las 4 tarjetas de conteo -->
      <section class="lg2-slide" [class.is-active]="slideIdx === 0" [attr.aria-hidden]="slideIdx !== 0">
        <div class="lg2-ill" aria-hidden="true">
          <div class="lg2-ill-halo"></div>
          <div class="lg2-ic lg2-ic--main">
            <div class="lg2-ic-hd"><i class="fas fa-tachometer-alt"></i> Dashboard</div>
            <div class="lg2-kpis">
              <div class="lg2-kpi"><i class="fas fa-eye lg2-c-green"></i><div><b>12</b><small>Open New Orders</small></div></div>
              <div class="lg2-kpi"><i class="fas fa-tasks lg2-c-orange"></i><div><b>5</b><small>Work Orders in Progress</small></div></div>
              <div class="lg2-kpi"><i class="fas fa-hourglass lg2-c-red"></i><div><b>2</b><small>Fault Detected</small></div></div>
              <div class="lg2-kpi"><i class="fas fa-thumbs-up lg2-c-blue"></i><div><b>4</b><small>Open Recommendations</small></div></div>
            </div>
          </div>
          <div class="lg2-ic lg2-ic--chip lg2-ic--bl"><i class="fas fa-book"></i> Knowledge Base Articles</div>
          <span class="lg2-bubble lg2-bubble--1"><i class="fas fa-chart-pie"></i></span>
          <span class="lg2-bubble lg2-bubble--2"><i class="fas fa-bell"></i></span>
          <span class="lg2-bubble lg2-bubble--3"><i class="fas fa-lightbulb"></i></span>
        </div>
        <h2 class="lg2-slide-title">Your service at a glance</h2>
        <p class="lg2-slide-txt">Open orders, work in progress, detected faults and recommendations, right on your dashboard.</p>
      </section>

      <!-- 2 · Service Work Order: grid Open Service Work Orders (ID, Report Issue, Technician, Status) -->
      <section class="lg2-slide" [class.is-active]="slideIdx === 1" [attr.aria-hidden]="slideIdx !== 1">
        <div class="lg2-ill" aria-hidden="true">
          <div class="lg2-ill-halo"></div>
          <div class="lg2-ic lg2-ic--main">
            <div class="lg2-ic-hd"><i class="fas fa-history"></i> Open Service Work Orders</div>
            <div class="lg2-li">
              <span class="lg2-li-id">1042</span>
              <span class="lg2-li-txt"><b>No cooling in lobby</b><small>J. Rivera · Oct 9</small></span>
              <span class="lg2-pill lg2-pill--sched">Scheduled</span>
            </div>
            <div class="lg2-li">
              <span class="lg2-li-id">1039</span>
              <span class="lg2-li-txt"><b>Controller offline</b><small>M. Lopez · Oct 7</small></span>
              <span class="lg2-pill lg2-pill--prog">In progress</span>
            </div>
            <div class="lg2-li">
              <span class="lg2-li-id">1031</span>
              <span class="lg2-li-txt"><b>Quarterly PM</b><small>A. Chen · Oct 2</small></span>
              <span class="lg2-pill lg2-pill--done">Completed</span>
            </div>
          </div>
          <div class="lg2-ic lg2-ic--wo lg2-ic--tr">
            <span class="lg2-wo-dot"></span>
            <div><b>Service Technician</b><small>Assigned to your order</small></div>
          </div>
          <span class="lg2-bubble lg2-bubble--1"><i class="fas fa-tools"></i></span>
          <span class="lg2-bubble lg2-bubble--2"><i class="fas fa-calendar-check"></i></span>
          <span class="lg2-bubble lg2-bubble--3"><i class="fas fa-clipboard-list"></i></span>
        </div>
        <h2 class="lg2-slide-title">Follow every service work order</h2>
        <p class="lg2-slide-txt">See each reported issue, the assigned technician, its status and the scheduled date.</p>
      </section>

      <!-- 3 · Service Sites / Assets Management: grid Service Sites (Site Name, Online, CUBE Score) -->
      <section class="lg2-slide" [class.is-active]="slideIdx === 2" [attr.aria-hidden]="slideIdx !== 2">
        <div class="lg2-ill" aria-hidden="true">
          <div class="lg2-ill-halo"></div>
          <div class="lg2-ic lg2-ic--main">
            <div class="lg2-ic-hd"><i class="fas fa-map-marked-alt"></i> Service Sites</div>
            <div class="lg2-site">
              <span class="lg2-site-dot lg2-site-dot--on"></span>
              <span class="lg2-site-name">Main Campus</span>
              <span class="lg2-score lg2-score--good">92</span>
            </div>
            <div class="lg2-site">
              <span class="lg2-site-dot lg2-site-dot--on"></span>
              <span class="lg2-site-name">North Tower</span>
              <span class="lg2-score lg2-score--good">87</span>
            </div>
            <div class="lg2-site">
              <span class="lg2-site-dot"></span>
              <span class="lg2-site-name">Warehouse 3</span>
              <span class="lg2-score lg2-score--mid">64</span>
            </div>
            <div class="lg2-ic-total"><span>3 sites</span><b>2 online</b></div>
          </div>
          <div class="lg2-ic lg2-ic--chip lg2-ic--tr"><i class="fas fa-microchip"></i> Assets Management</div>
          <span class="lg2-bubble lg2-bubble--1"><i class="fas fa-building"></i></span>
          <span class="lg2-bubble lg2-bubble--2"><i class="fas fa-thermometer-half"></i></span>
          <span class="lg2-bubble lg2-bubble--3"><i class="fas fa-wifi"></i></span>
        </div>
        <h2 class="lg2-slide-title">Your sites and assets, monitored</h2>
        <p class="lg2-slide-txt">Check which sites are online, their CUBE Score, and the systems and assets in each one.</p>
      </section>
    </div>

    <!-- indicadores: el activo se alarga y se llena en 6s; al terminar esa animacion (animationend)
         pasa al siguiente. Hover pausa la animacion = pausa el autoplay, sin timers. -->
    <div class="lg2-dots" role="tablist" aria-label="Slides">
      <button type="button" *ngFor="let s of slides; let i = index" class="lg2-dot" role="tab"
        [class.is-active]="slideIdx === i" [class.is-paused]="slidesPaused"
        [attr.aria-selected]="slideIdx === i" [attr.aria-label]="s"
        (click)="goToSlide(i)"><span (animationend)="nextSlide()"></span></button>
    </div>
  </aside>

  <!-- ── Panel del formulario (derecha) ── -->
  <main class="lg2-form-wrap">
    <div class="lg2-card">

      <h2 class="lg2-title">{{ 'ModuleLogin.labelSigninTitle' | translate }}</h2>
      <p class="lg2-subtitle">{{ 'ModuleLogin.labelSigninSub' | translate }}</p>

      <!-- (ngSubmit): Enter en cualquier campo inicia sesion. El guard !isLoading evita el doble envio. -->
      <form [formGroup]="cardForm" class="lg2-form" (ngSubmit)="!isLoading && onSubmit()" novalidate>

        <!-- Email (el control se sigue llamando username) -->
        <div class="lg2-field">
          <label for="ccc">{{ 'ModuleLogin.labelEmail' | translate }}</label>
          <div class="lg2-input"
            [class.is-invalid]="submitted && cardForm.controls.username.invalid"
            [class.is-valid]="cardForm.controls.username.valid">
            <span class="lg2-input-icon"><i class="fas fa-envelope"></i></span>
            <input type="email" id="ccc" formControlName="username" autocomplete="username"
              maxlength="254" required autofocus
              [attr.aria-invalid]="submitted && cardForm.controls.username.invalid"
              aria-describedby="err-user"
              placeholder="name@company.com">
          </div>
          <div class="lg2-err" id="err-user" *ngIf="submitted && cardForm.controls.username.invalid">
            <i class="fas fa-exclamation-circle"></i>
            <span *ngIf="cardForm.controls.username.errors?.required">{{ 'ModuleLogin.msgvalidReqUser' | translate }}</span>
            <span *ngIf="cardForm.controls.username.errors?.email">{{ 'ModuleLogin.msgvalidEmail' | translate }}</span>
          </div>
        </div>

        <!-- Password (el "Forgot password?" va pegado al campo) -->
        <div class="lg2-field">
          <div class="lg2-label-row">
            <label for="ddd">{{ 'ModuleLogin.labelPasswd' | translate }}</label>
            <a routerLink="/RecoverPasswordCS" class="lg2-forgot">{{ 'ModuleLogin.labelforgotPasswd' | translate }}</a>
          </div>
          <div class="lg2-input lg2-input--pass"
            [class.is-invalid]="submitted && cardForm.controls.password.invalid"
            [class.is-valid]="cardForm.controls.password.valid">
            <span class="lg2-input-icon"><i class="fas fa-lock"></i></span>
            <input [type]="typeInputPassword" id="ddd" formControlName="password" autocomplete="current-password"
              maxlength="128" required
              (keyup)="onPasswordKey($event)" (blur)="capsOn = false"
              [attr.aria-invalid]="submitted && cardForm.controls.password.invalid"
              aria-describedby="err-pass caps-warn"
              placeholder="••••••••">
            <button type="button" class="lg2-input-eye" (click)="togglePassword()"
              [attr.aria-label]="'ModuleLogin.labelShowPassword' | translate"
              [title]="'ModuleLogin.labelShowPassword' | translate">
              <i class="far" [class.fa-eye]="!showPassword" [class.fa-eye-slash]="showPassword"></i>
            </button>
          </div>
          <!-- aviso de Bloq Mayus antes de fallar el login -->
          <div class="lg2-caps" id="caps-warn" *ngIf="capsOn">
            <i class="fas fa-arrow-up"></i> {{ 'ModuleLogin.labelCapsOn' | translate }}
          </div>
          <div class="lg2-err" id="err-pass" *ngIf="submitted && cardForm.controls.password.invalid">
            <i class="fas fa-exclamation-circle"></i>
            <span *ngIf="cardForm.controls.password.errors?.required">{{ 'ModuleLogin.msgvalidReqPasswd' | translate }}</span>
          </div>
        </div>

        <!-- Error del servidor (usuario/clave incorrectos): anunciado a lectores de pantalla -->
        <div class="lg2-alert" *ngIf="showError" role="alert" aria-live="assertive">
          <i class="fas fa-exclamation-circle"></i>
          <span>{{ msgError }}</span>
        </div>

        <!-- Submit: el estado de carga se ve en el propio boton -->
        <button type="submit" class="lg2-submit" [disabled]="isLoading" [class.is-loading]="isLoading">
          <dx-load-indicator *ngIf="isLoading" [visible]="true" height="18" width="18"></dx-load-indicator>
          <span>{{ (isLoading ? 'ModuleLogin.labelSigningIn' : 'ModuleLogin.btnSignin') | translate }}</span>
          <i class="fas fa-arrow-right lg2-submit-arrow" *ngIf="!isLoading"></i>
        </button>

        <!-- Alta de usuario OCULTA a pedido del usuario (2026-10-13): el registro publico queda deshabilitado
             y /createuser redirige al login (app.routes.ts). Para reactivarlo: descomentar este bloque y la ruta.
        <div class="lg2-register">
          <span>{{ 'ModuleLogin.labelNoAccount' | translate }}</span>
          <a routerLink="/createuser">{{ 'ModuleLogin.labelRegisterNow' | translate }}</a>
        </div> -->

      </form>
    </div>
  </main>
</div>
